import { Dialog, LinearProgress, Stack } from '@mui/material';
import React, { useContext } from 'react';
import UIContext from '../../context/UIContext';
import Loader from '../../Loaders/Loader';
import './Loading.css';

const Loading = () => {
  const { openLoader } = useContext(UIContext);
  return (
    // <Dialog
    //   open={openLoader}
    //   aria-labelledby="alert-dialog-title"
    //   aria-describedby="alert-dialog-description"
    //   fullWidth
    //   PaperProps={{
    //     sx: {
    //       backgroundColor: 'transparent',
    //       boxShadow: 'none',
    //       display: 'flex',
    //       justifyContent: 'center',
    //       alignItems: 'center',
    //     },
    //   }}
    // >
    //   <Stack
    //     sx={{
    //       justifyContent: 'center',
    //       alignItems: 'center',
    //       width: '100%',
    //       backgroundColor: '#ffffff00',
    //     }}
    //   >
    <div className="loader">
      <div className="loader__balls">
        <div className="loader__balls__group">
          <div className="ball item1">{''}</div>
          <div className="ball item1">{''}</div>
          <div className="ball item1">{''}</div>
        </div>
        <div className="loader__balls__group">
          <div className="ball item2">{''}</div>
          <div className="ball item2">{''}</div>
          <div className="ball item2">{''}</div>
        </div>
        <div className="loader__balls__group">
          <div className="ball item3">{''}</div>
          <div className="ball item3">{''}</div>
          <div className="ball item3">{''}</div>
        </div>
      </div>
    </div>
    //   </Stack>
    // </Dialog>
  );
};

export default Loading;
